import React from 'react';
import './styles/Footer.css';

const Footer = () => {
  return (
    <footer className="portfolio-footer">
      <p>
        &copy; {new Date().getFullYear()}{" "}
        <a href="/" className="footer-link">Juan Ansaldo</a>
      </p>
    </footer>
  );
};

export default Footer;